import Flex from '~/common/components/Flex';
import Text from '~/common/components/Texts/Text';

type FormulasProps = {
  formulas: any[];
};

const Formulas = ({ formulas }: Readonly<FormulasProps>) => {
  const arr = formulas.map((formula) => formula.formula);
  const handleMultiLineFormula = (arr) => {
    const spaced = arr.map((val) => {
      if (val.trim() === '') {
        return <br key={val} />;
      } else {
        return val;
      }
    });
    return spaced.map((val) => (
      <Text fontSize="14px" sx={{ display: 'inline' }} key={val}>
        {val}
      </Text>
    ));
  };

  return (
    <Flex pb={4} alignItems="flex-start">
      <Text mr={1} fontSize="14px" fontWeight="bold" d="inline">
        Calculation:
      </Text>
      <Flex flexDirection="column">{handleMultiLineFormula(arr)}</Flex>
    </Flex>
  );
};
export default Formulas;
